import React from 'react';
import { Link } from 'gatsby';
import { Breadcrumb } from 'antd';
import { Route } from 'antd/lib/breadcrumb/Breadcrumb';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/pro-light-svg-icons';

type Props = {
  routes: Route[];
  color?: string;
};

type Icon = {
  icon: string;
};

const PageBreadcrumb = ({ routes, color = 'light' }: Props) => {
  const isHome = (path: string) => path === '/';

  const itemRender = (route: Route) => (
    <Link to={route.path} activeClassName="active-link">
      {isHome(route.path) && <FontAwesomeIcon size="1x" icon={faHome} />}
      {!isHome(route.path) && route.breadcrumbName}
    </Link>
  );

  return (
    <Breadcrumb
      routes={routes}
      itemRender={itemRender}
      className={color}
    ></Breadcrumb>
  );
};

export default PageBreadcrumb;
